import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faInfoCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import './ConfirmDialog.css';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, onCancel, title, message, type = 'confirm', confirmText = 'Confirmar', cancelText = 'Cancelar' }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      if (onCancel) onCancel();
      else onClose();
    }
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    else onClose();
  };

  const getIcon = () => {
    switch (type) {
      case 'warning':
        return faExclamationTriangle;
      case 'info':
        return faInfoCircle;
      case 'success':
        return faCheckCircle;
      default:
        return faExclamationTriangle;
    }
  };

  const getIconColor = () => {
    switch (type) {
      case 'warning':
        return '#f59e0b';
      case 'info':
        return '#3b82f6';
      case 'success':
        return '#22c55e';
      default:
        return '#f59e0b';
    }
  };

  return (
    <div className="confirm-dialog-overlay" onClick={handleBackdropClick}>
      <div className="confirm-dialog">
        <div className="confirm-dialog-header">
          <div className="confirm-dialog-icon" style={{ color: getIconColor() }}>
            <FontAwesomeIcon icon={getIcon()} />
          </div>
          {title && <h3 className="confirm-dialog-title">{title}</h3>}
        </div>
        
        <div className="confirm-dialog-body">
          <p className="confirm-dialog-message">{message}</p>
        </div>
        
        <div className="confirm-dialog-footer">
          {cancelText && (
            <button
              className="confirm-dialog-btn confirm-dialog-btn-cancel"
              onClick={handleCancel}
            >
              {cancelText}
            </button>
          )}
          <button
            className={`confirm-dialog-btn confirm-dialog-btn-confirm confirm-dialog-btn-${type}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;

